import { Control, FieldPath, FieldValues } from 'react-hook-form';

import { Checkbox } from '../ui/checkbox';
import { FormControl, FormDescription, FormField, FormItem, FormLabel } from '../ui/form';

interface CheckboxFieldProps<TFieldValues extends FieldValues> {
  control: Control<TFieldValues>;
  name: FieldPath<TFieldValues>;
  label: string;
  description?: string;
}

const CheckboxField = <TFieldValues extends FieldValues>(
  props: CheckboxFieldProps<TFieldValues>,
) => {
  const { control, name, label, description } = props;
  return (
    <FormField
      control={control}
      name={name}
      render={({ field }) => (
        <FormItem className="flex flex-row items-start space-x-3 space-y-0">
          <FormControl>
            <Checkbox checked={field.value} onCheckedChange={field.onChange} />
          </FormControl>
          <div className="space-y-1 leading-none">
            <FormLabel>{label}</FormLabel>
            {description && <FormDescription>{description}</FormDescription>}
          </div>
        </FormItem>
      )}
    />
  );
};

export default CheckboxField;
